<template>
  <div>
    <el-dialog :visible.sync="showtag" :title="articleWords + $t('widgets_basic_article_classification_index_337')" style="padding-bottom: 20px;" custom-class="el-popup-parent-imgPop--dialog" class="tableData" append-to-body v-dialogDrag width="762px"  @close="close_dialog">
      <div class="tableDatapart">
        <div class="addNavPart">
          <p class="title">{{$t('components_basic_management_index_2179', [ articleWords ])}}</p>
          <el-button size="small" @click="openAddClass('add', '0', '0')">{{$t('components_basic_addarticle_message_2030')}}</el-button>
        </div>
        <div class="headerLine">
          <!-- <span>id</span> -->
          <span class="ce_1 firstLine">{{$t('components_basic_management_index_2180')}}</span>
          <span class="ce_2">{{$t('view_form_dialog_add_form_215')}}</span>
          <span class="ce_3">{{$t('view_form_dialog_add_form_216')}}</span>
        </div>
      </div>
      <ul class="typePart" v-if='treeData.length !== 0'>
        <li class="navTopline"  v-for="(parentVal, parentIndex) in treeData" :key="parentIndex" v-if="rander">
          <div class="linePart ">
            <div class="title ce_1" style="width: 227px;">
              <div class="stopPart" @mousedown.stop>
                <i
                  v-if="parentVal.children && parentVal.children.length != 0"
                  :class="parentVal.childShow == 'false' ? 'el-icon-caret-right' : 'el-icon-caret-bottom'"
                  style="padding-right: 5px;"
                  @click="changeShow(parentVal)"
                ></i>
              </div>
              <span>{{ parentVal.name }}</span>
            </div>
            <div class="ce_2">
              <div class="el-icon-btn" @mousedown.stop v-if="parentIndex != 0"><a class="el-icon-top" @click="changeIndex(treeData, parentIndex, parentVal, -1)"></a></div>
              <div class="el-icon-btn" @mousedown.stop v-if="parentIndex != treeData.length - 1">
                <a class="el-icon-bottom" @click="changeIndex(treeData, parentIndex, parentVal, +1)"></a>
              </div>
            </div>
            <div class="contorlPart ce_3">
              <div @mousedown.stop class="iconPart"><span @click="openAddClass('edit', parentVal.pid, parentVal.id)" class="editIcon" :title="$t('components_basic_addarticle_index_2003')"></span></div>
              <div @mousedown.stop class="iconPart"><span @click="openAddClass('add', parentVal.id, parentVal.id)" class="addIcon" :title="$t('components_basic_addarticle_index_2004')"></span></div>
              <div @mousedown.stop class="iconPart"><span @click="deletePage(parentVal)" class="deleteIcon" :title="$t('view_god_set_index_226')"></span></div>
            </div>
          </div>
          <ul class="typeChildPart" :style="{ display: parentVal.childShow == 'false' ? 'none' : 'block' }">
            <li class="typeChildline" style="padding-left:20px;" v-for="(childVal, childIndex) in parentVal.children" :key="childIndex" v-if="parentVal.children">
              <div class="childLinepart">
                <!-- <span class="id">{{ childVal.id }}</span> -->
                <b class="childTagIcon"></b>
                <div class="title ce_1 paddingL" style="width: 227px;">
                  <div class="stopPart">
                    <i
                        v-if="childVal.children && childVal.children.length != 0"
                        class="i-tag"
                        :class="childVal.childShow == 'false' ? 'el-icon-caret-right' : 'el-icon-caret-bottom'"
                        @click="changeShow(childVal)"
                      ></i>
                  </div>
                  <span>{{ childVal.name }}</span>
                </div>
                <div class="ce_2">
                  <div class="el-icon-btn" @mousedown.stop v-if="childIndex != 0">
                    <a class="el-icon-top" @click="changeIndex(treeData[parentIndex].children, childIndex, childVal, -1)"></a>
                  </div>
                  <div class="el-icon-btn" @mousedown.stop v-if="childIndex != parentVal.children.length - 1">
                    <a class="el-icon-bottom" @click="changeIndex(treeData[parentIndex].children, childIndex, childVal, +1)"></a>
                  </div>
                </div>
                <div class="ce_3 contorlPart">
                  <div @mousedown.stop class="iconPart"><span @click="openAddClass('edit', childVal.pid, childVal.id)" class="editIcon" :title="$t('components_basic_addarticle_index_2003')"></span></div>

                  <div @mousedown.stop class="iconPart"><span @click="openAddClass('add', childVal.id, childVal.id)" class="addIcon" :title="$t('components_basic_addarticle_index_2004')"></span></div>
                  <!-- 现有删除逻辑需要调整 -->
                  <div @mousedown.stop class="iconPart"><span @click="deletePage(childVal)" class="deleteIcon" :title="$t('view_god_set_index_226')"></span></div>
                </div>
              </div>
              <ul class="typeChildPart" :style="{ display: childVal.childShow == 'false' ? 'none' : 'block' }">
                <li class="typeChildline" v-for="(childVal2, childIndex2) in childVal.children" :key="childIndex2" v-if="childVal.children">
                  <div class="childLinepart ">
                    <!-- <span class="id">{{ childVal.id }}</span> -->
                    <b class="childTagIcon"></b>
                    <div class="title ce_1 paddingL2" style="width: 227px;">
                      <span>
                        <!-- <i
                          v-if="childVal2.children && childVal2.children.length != 0"
                          class="i-tag"
                          :class="childVal2.childShow == 'false' ? 'el-icon-caret-right' : 'el-icon-caret-bottom'"
                          style="padding-right: 5px;"
                          @click="changeShow(childVal2)"
                        ></i> -->
                        {{ childVal2.name }}
                      </span>
                    </div>
                    <div class="ce_2">
                      <div class="el-icon-btn" @mousedown.stop v-if="childIndex2 != 0">
                        <a class="el-icon-top" @click="changeIndex(treeData[parentIndex].children[childIndex].children, childIndex2, childVal2, -1)"></a>
                      </div>
                      <div class="el-icon-btn" @mousedown.stop v-if="childIndex2 != childVal.children.length - 1">
                        <a class="el-icon-bottom" @click="changeIndex(treeData[parentIndex].children[childIndex].children, childIndex2, childVal2, +1)"></a>
                      </div>
                    </div>
                    <div class="ce_3 contorlPart">
                      <div @mousedown.stop class="iconPart"><span @click="openAddClass('edit', childVal2.pid, childVal2.id)" class="editIcon" :title="$t('components_basic_addarticle_index_2003')"></span></div>

                      <div @mousedown.stop class="iconPart"><span style="cursor: not-allowed" class="disaddIcon" :title="$t('components_basic_addarticle_index_2004')"></span></div>
                      <!-- 现有删除逻辑需要调整 -->
                      <div @mousedown.stop class="iconPart"><span @click="deletePage(childVal2)" class="deleteIcon" :title="$t('view_god_set_index_226')"></span></div>
                    </div>
                  </div>
                  <ul class="typeChildPart" style="display: none">
                    <li class="typeChildline" v-for="(childVal3, childIndex3) in childVal2.children" :key="childIndex3" v-if="childVal2.children">
                      <div class="childLinepart ">
                        <!-- <span class="id">{{ childVal.id }}</span> -->
                        <b class="childTagIcon"></b>
                        <div class="title ce_1 paddingL3" style="width: 227px;">
                          <span>{{ childVal3.name }}</span>
                        </div>
                        <div class="ce_2">
                          <div class="el-icon-btn" @mousedown.stop v-if="childIndex3 != 0">
                            <a class="el-icon-top" @click="changeIndex(treeData[parentIndex].children[childIndex].children[childIndex2].children, childIndex3, childVal3, -1)"></a>
                          </div>
                          <div class="el-icon-btn" @mousedown.stop v-if="childIndex3 != childVal2.children.length - 1">
                            <a
                              class="el-icon-bottom"
                              @click="changeIndex(treeData[parentIndex].children[childIndex].children[childIndex2].children, childIndex3, childVal3, +1)"
                            ></a>
                          </div>
                        </div>
                        <div class="ce_3 contorlPart">
                          <div @mousedown.stop class="iconPart"><span @click="openAddClass('edit', childVal3.pid, childVal3.id)" class="editIcon" :title="$t('components_basic_addarticle_index_2003')"></span></div>
                          <div @mousedown.stop class="iconPart"><span class="addIcon stopClick" :title="$t('components_basic_addarticle_index_2004')"></span></div>
                          <div @mousedown.stop class="iconPart"><span @click="deletePage(childVal3)" class="deleteIcon" :title="$t('view_god_set_index_226')"></span></div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
      <div class="noDataTip" v-if='treeData.length === 0'>
        <p>{{$t('components_basic_management_index_2181', [articleWords])}}</p>
      </div>
      <div class="countPart">
        <p>{{$t('components_basic_management_index_2182', [ total ])}}</p>
      </div>
      <div class="bottomBtn">
        <el-button size="medium" type="primary" @click="saveBothType" :disabled="confirmDisabled">{{$t('view_public_topbar_15')}}</el-button>
        <el-button size="medium" @click="close_dialog">{{$t('view_public_topbar_14')}}</el-button>
      </div>
    </el-dialog>

    <basic_addType v-if="isShow" :isShow.sync="isShow" :proParams="proParams" @getNewTypeList="getNewTypes" :treeData="treeData"></basic_addType>
    <basic_deleteType
      :showPop.sync="showPop"
      :typeId="typeTag"
      :popTreedata="treeData"
      :checkID="checkID"
      :typeValue="typeValue"
      @getNewTypeList="getNewTypes"
    ></basic_deleteType>
  </div>
</template>

<script>
import i18n from '../../language/index'

import { saveBothArticleType, saveBothProType, gettypeList, proTypeList } from '@/api/app.js';
import {lockScroll} from '@/base/base'
export default {
  props: {
    typeTag: {
      //type 1:文章 2:帮助 3:案例 4:下载 11:视频,5:图册,0:产品
      type: Number,
      default: 1
    },
    showTag: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    dataVisible(val, oldVal) {
      this.$emit('update:showTag', val);
    },
    // showTag(val) {
    //   // 数据双向绑定
    //   this.dataVisible = val;
    // },
    typeTag() {
      this.changeWords();
      this.getTypes();
    },
    treeData () {
      if (!this.isFirstWatch) {
        this.confirmDisabled = false
      } else {
        this.isFirstWatch = false
      }
    }
  },
  data() {
    return {
      showtag: true,
      proParams: {
        title: i18n.t('components_basic_addarticle_index_2009'),
        type: 'add', // 类型： 新增（add）或编辑(edit)
        twebId: 0, // 网站ID
        pid: '0', // 分类类型pid
        id: '0', // 分类类型ID
        objectType: 'news', //  新增或编辑对象的类型 pro 分类类型
        typevalue: 1
      },
      total: 0,
      treeData: [],
      articleWords: i18n.t('widgets_basic_article_classification_edit_333'),
      rander: true,
      typeValue: 1, //1 产品逻辑 2 文章逻辑
      checkID: 0,
      showPop: false,
      navVisible: true,
      dataVisible: this.showTag,
      isShow: false,
      changeType: false,
      isFirstWatch: true,
      confirmDisabled: true
    };
  },
  methods: {
    getNewTypes() {
      this.changeType = true;
      this.getTypes();
    },
    closepage() {
      this.navVisible = true;
      this.dataVisible = false;
      this.$emit('changeType');
      this.$emit('closed');
      this.$nextTick(()=> {
          lockScroll(false)
        })
    },
    close_dialog () {
      this.showtag = true
      if (!this.confirmDisabled) {
        this.$confirm(i18n.t('view_dialog_index_170'), {
          confirmButtonText: i18n.t('view_public_topbar_24'),
          cancelButtonText: i18n.t('view_public_topbar_11'),
          type: 'warning'
        }).then(() => {
          // 不保存退出
          this.showtag = false
          this.closepage()
        }).catch(() => {
          // 啥也不做
        })
      } else {
        // 保存
        this.showtag = false
        this.closepage()
        // this.saveBothType()
      }
      this.$nextTick(()=> {
          lockScroll(false)
        })
    },
    clearData(data) {
      if (data instanceof Array) {
        for (let i = 0; i < data.length; i++) {
          delete data[i].childShow;
          delete data[i].level;
          delete data[i].createtime;
          delete data[i].updatetime;
          this.clearData(data[i]);
        }
      } else if (data.children && data.children instanceof Array && data.children.length > 0) {
        for (let i = 0; i < data.children.length; i++) {
          delete data.children[i].childShow;
          delete data.children[i].level;
          delete data.children[i].createtime;
          delete data.children[i].updatetime;
          this.clearData(data.children[i]);
        }
      }
    },
    saveBothType() {
      if(this.treeData.length === 0){
        this.closepage();
        return false
      }
      let actionList = [saveBothArticleType, saveBothProType];
      let action = '';
      if (this.typeTag !== 0) {
        action = actionList[0];
      } else {
        action = actionList[1];
      }
      let sendData = this.treeData;
      this.clearData(sendData);
      action(sendData).then(res => {
        if (res.code === 200) {
          if (this.changeType) {
            this.$emit('changeType');
          }
          this.$message.success(res.message);
          this.closepage();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    changeWords() {
      let type = this.typeTag;
      //1:新闻 2:帮助 3:案例 4:下载 5:图册 11:视频
      switch (type) {
        case 0:
          this.articleWords = i18n.t('widgets_basic_classification_edit_482');
          this.proParams.objectType = 'product';
          break;
        case 1:
          this.articleWords = i18n.t('widgets_basic_article_classification_edit_333');
          this.proParams.objectType = 'news';
          break;
        case 2:
          this.articleWords = i18n.t('widgets_basic_article_classification_edit_335');
          this.proParams.objectType = 'help';
          break;
        case 3:
          this.articleWords = i18n.t('widgets_basic_article_classification_edit_334');
          this.proParams.objectType = 'case';
          break;
        case 4:
          this.articleWords = i18n.t('router_index_69');
          this.proParams.objectType = 'download';
          break;
        case 5:
          this.articleWords = i18n.t('components_basic_addarticle_index_2010');
          this.proParams.objectType = 'atlas';
          break;
        case 11:
          this.articleWords = i18n.t('view_download_index_181');
          this.proParams.objectType = 'video';
          break;
      }
      this.proParams.title = i18n.t('components_basic_addarticle_index_2004') + this.articleWords + i18n.t('widgets_basic_article_info_edit_348');
      this.proParams.typevalue = this.typeTag;
    },
    openAddClass(isAddOrEdit, pid, id) {
      const info = isAddOrEdit === 'edit' ? i18n.t('components_basic_addarticle_index_2003') + this.articleWords + i18n.t('widgets_basic_article_info_edit_348') : i18n.t('components_add_button_index_1953') + this.articleWords + i18n.t('widgets_basic_article_info_edit_348');
      this.proParams.typevalue = this.typeTag;
      this.proParams.title = info;
      this.proParams.pid = pid;
      this.proParams.type = isAddOrEdit;
      this.proParams.id = id;
      this.isShow = true;
      if (this.proParams.objectType === 'product') {
        this.typeValue = 1;
      } else {
        this.typeValue = 2;
      }
    },
    changeIndex(proData, chIndex, data, index) {
      proData.splice(chIndex, 1);
      proData.splice(chIndex + index, 0, data);
    },
    changeShow(preData) {
      preData.childShow == 'false' ? (preData.childShow = 'true') : (preData.childShow = 'false');
      this.rander = false;
      this.$nextTick(() => {
        this.rander = true;
      });
    },
    //删除分类
    deletePage(item) {
      if (this.proParams.objectType === 'product') {
        this.typeValue = 1;
      } else {
        this.typeValue = 2;
      }
      this.checkID = item.id;
      this.showPop = true;
    },
    set_level(data) {
      if (data instanceof Array) {
        for (let i = 0; i < data.length; i++) {
          data[i].level = 1;
          this.set_level(data[i]);
        }
      } else if (data.children && data.children instanceof Array && data.children.length > 0) {
        data.childShow = 'false';
        for (let i = 0; i < data.children.length; i++) {
          data.children[i].level = data.level + 1;
          this.set_level(data.children[i]);
        }
      }
    },
    getTotal(data) {
      let that = this
      data.forEach(parent=> {
        that.total = that.total + 1
        parent.level = 1;
        if(parent.children && parent.children.length > 0) {
            parent.children.forEach(child=> {
              that.total = that.total + 1
              child.level = 2;
                if(child.children && child.children.length > 0) {
                    child.children.forEach(child2=> {
                      child2.level = 3;
                      that.total = that.total + 1
                    })
                }
            })
        }
      })
    },
    getTypes() {
      let actionList = [gettypeList, proTypeList];
      let action = '';
      if (this.typeTag !== 0) {
        action = actionList[0];
      } else {
        action = actionList[1];
      }
      let type = {
        type: this.typeTag ? this.typeTag : '',
      };
      action(type)
        .then(res => {
          if (res.code === 200 && res.data) {
            let dataList = [];
            if (this.typeTag && res.data.list instanceof Array) {
              dataList = res.data.list;
            } else if (!this.typeTag && res.data.rows instanceof Array) {
              dataList = res.data.rows;
            }
            this.total = 0
            //this.set_level(dataList);
            this.getTotal(dataList)
            this.treeData = dataList.map(item => {
              return item;
            });
            //this.total = res.data.total;
          } else {
            this.treeData = [];
          }
        })
        .catch(err => {
          this.$message.error(err.message);
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  mounted() {
    lockScroll(true)
    this.changeWords();
    this.getTypes();
  }
};
</script>

<style scoped type="text/css" lang="scss">
.tableData {
  .bottomBtn {
    /deep/ .el-button {
      margin: 0 18px;
      padding: 0 28px;
      height: 34px;
    }
  }
}
.typePart {
  position: relative;
  height: 350px;
  overflow-y: auto;
  border-bottom: 1px solid #efefef;
  .navTopline {
    width: 100%;
    background-color: #fff;
    .linePart {
      font-size: 0;
      border-bottom: 1px solid #ebeef5;
      .contentPart {
      }
      > div {
        text-align: center;
        display: inline-block;
        line-height: 36px;
        padding: 7px 0;
        font-size: 14px;
        position: relative;
        span {
          width: 100%;
          line-height: 36px;
          display: block;
          text-align: left;
          margin-left: 27px;
        }
        .deleteIcon {
          width: 15px;
          height: 15px;
          cursor: pointer;
          background: url('../../assets/nav_icon/delete-icon.png');
        }
        .disdeleteIcon {
          width: 15px;
          height: 15px;
          cursor: not-allowed;
          background: url('../../assets/nav_icon/disdelete-icon.png');
        }
        .editIcon {
          width: 15px;
          height: 15px;
          cursor: pointer;
          background: url('../../assets/nav_icon/edit-icon.png');
        }
        .addIcon {
          width: 15px;
          height: 15px;
          cursor: pointer;
          background: url('../../assets/nav_icon/add-icon.png');
        }
        .copyIcon {
          width: 15px;
          height: 15px;
          cursor: pointer;
          background: url('../../assets/nav_icon/copy-icon.png');
        }
        .discopyIcon {
          width: 15px;
          height: 15px;
          cursor: not-allowed;
          background: url('../../assets/nav_icon/discopy-icon.png');
        }
        .stopPart {
          cursor: pointer;
          position: absolute;
          left: 7px;
          top: 0;
          z-index: 9999;
          height: 50px;
          line-height: 50px;
          width: 20px;
          display: block;
        }
        em {
          text-align: center;
          padding: 0 10px;
          cursor: pointer;
        }
        .el-icon-btn {
          cursor: pointer;
          display: inline-block;
          width: 8px;
          height: 13px;
          margin-right: 10px;
          color: #999;
          a {
            color: #999;
          }
        }
        .el-icon-btn:hover a {
          color: #999;
          background-color: #f4f4f4;
        }
      }
      .contorlPart {
        .iconPart {
          display: inline-block;
          margin: 0 5px;
        }
        span {
          margin: unset;
          display: inline-block;
        }
      }
    }
  }
}
.typeChildPart {
  .paddingL {
    padding-left: 35px;
    position: relative;
  }
}
.dropLi {
  cursor: move;
}
.typeChildline {
  width: 100%;
  background-color: #fff;
  .childLinepart {
    border-bottom: 1px solid #ebeef5;
    font-size: 0;
    > div {
      text-align: center;
      display: inline-block;
      line-height: 36px;
      padding: 7px 0;
      font-size: 14px;
      span {
        width: 100%;
        line-height: 36px;
        height: 36px;
        display: block;
        text-align: left;
        text-overflow: ellipsis;
        white-space: nowrap; 
        overflow: hidden;
      }
      .deleteIcon {
        width: 15px;
        height: 15px;
        cursor: pointer;
        background: url('../../assets/nav_icon/delete-icon.png');
      }
      .disdeleteIcon {
        width: 15px;
        height: 15px;
        cursor: not-allowed;
        background: url('../../assets/nav_icon/disdelete-icon.png');
      }
      .editIcon {
        width: 15px;
        height: 15px;
        cursor: pointer;
        background: url('../../assets/nav_icon/edit-icon.png');
      }
      .addIcon {
        width: 15px;
        height: 15px;
        cursor: pointer;
        background: url('../../assets/nav_icon/add-icon.png');
      }
      .disaddIcon {
        width: 15px;
        height: 15px;
        cursor: pointer;
        background: url("../../assets/nav_icon/disadd-icon.png");
      }
      .stopPart {
        cursor: pointer;
        position: absolute;
        left: 7px;
        top: 0;
        z-index: 9999;
        height: 50px;
        line-height: 50px;
        width: 20px;
        display: block;
      }
      .copyIcon {
        width: 15px;
        height: 15px;
        cursor: pointer;
        background: url('../../assets/nav_icon/copy-icon.png');
      }
      .discopyIcon {
        width: 15px;
        height: 15px;
        cursor: not-allowed;
        background: url('../../assets/nav_icon/discopy-icon.png');
      }
      em {
        text-align: center;
        padding: 0 10px;
        cursor: pointer;
      }
      .el-icon-btn {
        cursor: pointer;
        display: inline-block;
        width: 8px;
        height: 13px;
        margin-right: 10px;
        color: #999;
        a {
          color: #999;
        }
      }
      .el-icon-btn:hover a {
        color: #999;
        background-color: #f4f4f4;
      }
    }
    .paddingL {
      padding-left: 35px;
    }
    .paddingL2 {
      padding-left: 70px;
    }
    .paddingL3 {
      padding-left: 94px;
    }
    .contorlPart {
      .iconPart {
        display: inline-block;
        margin: 0 5px;
      }
      span {
        margin: unset;
        display: inline-block;
      }
    }
  }
}
.tableData {
  border-left: 1px solid #ebeef5;
  border-right: 1px solid #ebeef5;
}

.tableData /deep/ .paixu {
  width: 100%;
  height: 65px;
  background: #fff8a1;
  border: 1px #e3c818 dashed;
  margin-bottom: 7px;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  border-radius: 3px;
}

.tableData /deep/ .neipaixu {
  width: 100%;
  height: 65px;
  background: #fff8a1;
  border: 1px #e3c818 dashed;
  margin-bottom: 10px;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  border-radius: 3px;
}

.tableData .xuanfu {
  box-shadow: 5px 5px 5px #666;
  border: 1px #0026ff solid;
}
/deep/ .sort_Prompt {
  position: absolute;
  width: 100%;
  height: 64px;
  background: #477eff;
  text-align: center;
  line-height: 64px;
  color: #fff;
  top: 0;
  left: 0;
  z-index: 999999;
}
.mySortableModule {
  width: 375px;
  height: 30px;
  background: #ffe5cd;
  border: 1px #ec6941 dashed;
  list-style: none;
}
.noDataTip{
  height: 250px;
  text-align: center;
  font-size: 20px;
  color: #333;
  line-height: 250px;
}
.mySortableModule:before {
  content: '放这里';
  display: block;
  width: 100%;
  height: 100%;
  color: #ec6941;
  text-align: center;
  line-height: 30px;
}
.mySortableModule span {
  display: block;
  width: 100%;
  height: 100%;
  color: #ec6941;
  text-align: center;
  line-height: 30px;
}
/deep/ .Sortableitem_ing {
  height: 64px;
  overflow: hidden;
}
.contentLine {
  width: 100%;
  height: 64px;
}
.tableData {
  .headerLine {
    font-size: 0;
    height: 36px;
    line-height: 36px;
    background-color: #fafafa;
    span {
      font-size: 16px;
      display: inline-block;
      text-align: center;
    }
    .firstLine {
      text-align: left;
      margin-left: 27px;
      width: 197px;
    }
  }
  .ce_1 {
    width: 235px;
  }
  .ce_2 {
    width: 245px;
  }
  .ce_3 {
    width: 185px;
  }
  .ce_4 {
    width: 200px;
  }
}
.countPart {
  text-align: left;
  line-height: 14px;
  font-size: 14px;
  padding-top: 18px;
}
.bottomBtn {
  text-align: center;
  padding-top: 30px;
}
.determineBtn {
  width: 104px;
  color: #fff;
  background-color: #4c556d;
  border: 1px solid #4c556d;
}
.switch-icon {
  .el-icon-check {
    color: #7dc343;
  }
  .el-icon-close {
    color: #da4539;
  }
}

.ruleFormStyle {
  max-height: 500px;
  overflow-y: auto;
}
/deep/ .el-form-item__content {
  min-width: 300px;
  font-size: 0;
}
.describe {
  display: block;
  font-size: 12px;
  color: #999;
  line-height: 1.5;
  padding: 8px 0;
}

.add_type .el-form-item__label {
  width: 79px;
}

.add_type .el-form-item__content {
  margin-left: 84px;
}

.el-alert--warning {
  width: 910px;
}

.el-form .el-form-item__label {
  width: 154px !important;
}

.add0 .el-form-item__label {
  width: 152px !important;
}
.seotipswords {
  display: block;
  font-size: 12px;
  color: #999;
  line-height: 2;
}
.el-select .el-input .el-select__caret {
  color: #c0c4cc;
  font-size: 14px;
  transition: transform 0.3s;
  transform: rotate(180deg);
  cursor: pointer;
}

.area input::-webkit-input-placeholder {
  color: #606266;
}

.formItem .el-form-item__label:before {
  content: '*';
  color: #f56c6c;
  margin-right: 4px;
}
.step_1,
.step_2 {
  padding: 0;
}
.step_1 .el-form-item__content .el-input,
.step_2 .el-form-item__content .el-input,
.step_1 .el-form-item__content .el-select,
.step_2 .el-form-item__content .el-textarea {
  width: 260px;
  font-size: 12px;
}
.step_1 .el-form-item__content .el-input /deep/ .el-input__inner,
.step_2 .el-form-item__content .el-input /deep/ .el-input__inner,
.step_1 .el-form-item__content .el-select /deep/ .el-input__inner {
  height: 34px;
  line-height: 34px;
}
.addNavPart {
  height: 70px;
  .title {
    font-size: 14px;
    line-height: 70px;
    color: #666;
    float: left;
  }
  .el-button {
    float: right;
    margin: 19px 0;
  }
}
.i-tag {
  padding-right: 5px;
  cursor: pointer;
}
.stopClick {
  cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// src/components/basic_management/index.vue